import React, { Component,Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import Select from 'react-select';

const required = value => {
    if (!value) {
      return (
        <div className="alert alert-danger" role="alert">
          Este campo es obligatorio!
        </div>
      );
    }
  };

export class Ver_edit_customer_cluster extends Component {
    constructor(props) {
        super(props);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.onChangeClusterName = this.onChangeClusterName.bind(this);
        this.onChangeClusterCode = this.onChangeClusterCode.bind(this);
        this.onChangeStatus = this.onChangeStatus.bind(this);
        this.handleUsersChange = this.handleUsersChange.bind(this);
        this.handleAddUsers = this.handleAddUsers.bind(this);

        this.state = {
            cluster_name: "",
            cluster_code: "",
            cluster_status: "ACTIVO",
            selectedUsers: [],
            allUsers: [],
            clusterUsers: [],
            errors: {},
            loading: false,
            addingUsers: false,
        }
    }

    componentWillMount() {
        this.getDataCluster();
        this.getDataAllUsers();
        this.getClusterUsers();
    }

    getDataAllUsers(){
        var user = AuthService.getCurrentUser();
        ApiService.getConfirmUsers(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    const users = res.data.map(function(row) {
                        return {
                            value: row.id,
                            label: row.name + ' ' + row.last_name + (row.Profile && row.Profile.cell_phonenumber ? ' - ' + row.Profile.cell_phonenumber : '')
                        }
                    });
                    this.setState({ allUsers: users });
                }
            },
            error => {
            }
        );
    }

    getClusterUsers(){
        var user = AuthService.getCurrentUser();
        let id_cluster = this.props.match.params.id;
        ApiService.getClusterUsers(user.token, id_cluster).then(
            (res) => {
                if(res && res.status == 'success'){
                    this.setState({ clusterUsers: res.data || [] });
                }
            },
            error => {
            }
        );
    }

    handleUsersChange = (selectedOptions) => {
        this.setState({ selectedUsers: selectedOptions || [] });
    };

    handleAddUsers = () => {
        if(!this.state.selectedUsers || this.state.selectedUsers.length === 0){
            toast.warning("Por favor selecciona al menos un usuario.");
            return;
        }

        this.setState({ addingUsers: true });

        var user = AuthService.getCurrentUser();
        let id_cluster = this.props.match.params.id;
        let assignedCount = 0;
        let errorCount = 0;
        const totalUsers = this.state.selectedUsers.length;

        this.state.selectedUsers.forEach((selectedUser) => {
            let data = {
                id_user: selectedUser.value,
                id_cluster: id_cluster
            };

            ApiService.assignUserToCluster(user.token, data).then(
                (res) => {
                    if(res && res.status == 'success'){
                        assignedCount++;
                    } else {
                        errorCount++;
                    }

                    if(assignedCount + errorCount === totalUsers){
                        this.setState({
                            addingUsers: false,
                            selectedUsers: []
                        });
                        if(assignedCount > 0){
                            toast.success(`${assignedCount} usuario(s) asignado(s) correctamente!`);
                            this.getClusterUsers();
                        }
                        if(errorCount > 0){
                            toast.warning(`${errorCount} usuario(s) no pudieron ser asignados.`);
                        }
                    }
                },
                error => {
                    errorCount++;
                    if(assignedCount + errorCount === totalUsers){
                        this.setState({
                            addingUsers: false,
                            selectedUsers: []
                        });
                        if(assignedCount > 0){
                            toast.success(`${assignedCount} usuario(s) asignado(s) correctamente!`);
                            this.getClusterUsers();
                        }
                        if(errorCount > 0){
                            toast.warning(`${errorCount} usuario(s) no pudieron ser asignados.`);
                        }
                    }
                }
            );
        });
    };

    removeUserFromCluster = (userId, userName) => {
        Swal.fire({
            title: 'Confirmar',
            text: `¿Desea eliminar a ${userName} del grupo?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if(result.value){
                var user = AuthService.getCurrentUser();
                ApiService.removeUserFromCluster(user.token, userId).then(
                    (res) => {
                        if(res && res.status == 'success'){
                            toast.success(res.message);
                            this.getClusterUsers();
                        } else {
                            toast.error(res.message || "Error al eliminar usuario del grupo");
                        }
                    },
                    error => {
                        toast.error("Ha ocurrido un error al eliminar el usuario del grupo!");
                    }
                );
            }
        });
    };

    onChangeClusterName(e) {
        this.setState({
            cluster_name: e.target.value
        });
      }

      onChangeClusterCode(e) {
        this.setState({
            cluster_code: e.target.value
        });
      }

      onChangeStatus(e) {
        this.setState({
            cluster_status: e.target.value
        });
      }

      getDataCluster(){
        var user = AuthService.getCurrentUser();
        let id_cluster = this.props.match.params.id;
        ApiService.getCustomerClusterDetails(user.token, id_cluster).then(
            (res) => {
                if(res && res.status === 'success')
                {
                    this.setState({
                        cluster_name: res.data.cluster_name,
                        cluster_code: res.data.cluster_code || "",
                        cluster_status: res.data.cluster_status,
                    });
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }

      handleUpdate(e) {
        e.preventDefault();

        this.form.validateAll();

        if (this.checkBtn.context._errors.length === 0) {
            this.setState({
                message: "",
                loading: true
              });
            var user = AuthService.getCurrentUser();
            let id_cluster = this.props.match.params.id;
            let data_cluster = {
                'id_cluster': id_cluster,
                'cluster_name': this.state.cluster_name,
                'cluster_code': this.state.cluster_code,
                'cluster_status': this.state.cluster_status,
            }

            ApiService.putCustomerCluster(user.token, data_cluster).then(
            (res) => {
                if(res){
                    if(res.status == 'success')
                    {
                        this.props.history.push("/customer-clusters");
                        toast.success("Grupo actualizado!");
                    }
                    else
                    {
                        toast.error(res.message);
                        this.setState({
                            loading: false
                        });
                    }
                }else{
                    this.setState({
                        loading: false
                    });
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
              this.setState({
                loading: false
              });
              toast.error("Ha ocurrido un error!");
            }
          );
        }
      }

    render() {
        return (
            <Fragment>
                <Breadcrumb title="Editar Grupo de Clientes" parent="Promociones" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Editar Grupo de Clientes</h5>
                                </div>
                                <div className="card-body">
                                <Form
                                    onSubmit={this.handleUpdate}
                                    ref={c => {
                                        this.form = c;
                                    }}
                                >
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Nombre del Grupo</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="text"
                                                className="form-control"
                                                name="cluster_name"
                                                placeholder="Ej: Clientes que compran Frutas"
                                                value={this.state.cluster_name}
                                                onChange={this.onChangeClusterName}
                                                validations={[required]}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Código del Grupo</label>
                                        <div className="col-md-7">
                                            <Input
                                                type="text"
                                                className="form-control"
                                                name="cluster_code"
                                                placeholder="Ej: FRUTAS_2025 (Opcional)"
                                                value={this.state.cluster_code}
                                                onChange={this.onChangeClusterCode}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4"><span>*</span> Estado</label>
                                        <div className="col-md-7">
                                            <select
                                                name="cluster_status"
                                                className="form-control"
                                                value={this.state.cluster_status}
                                                onChange={this.onChangeStatus}
                                            >
                                                <option value="ACTIVO">ACTIVO</option>
                                                <option value="INACTIVO">INACTIVO</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="pull-right">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={this.state.loading}
                                        >
                                            {this.state.loading && (
                                            <span className="spinner-border spinner-border-sm"></span>
                                            )}
                                            Actualizar
                                        </button>
                                    </div>
                                    <CheckButton
                                        style={{ display: "none" }}
                                        ref={c => {
                                        this.checkBtn = c;
                                        }}
                                    />
                                </Form>
                                </div>
                            </div>

                            <div className="card mt-4">
                                <div className="card-header">
                                    <h5>Gestión de Usuarios del Grupo</h5>
                                </div>
                                <div className="card-body">
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">Agregar Usuarios</label>
                                        <div className="col-md-7">
                                            <Select
                                                isMulti
                                                value={this.state.selectedUsers}
                                                onChange={this.handleUsersChange}
                                                options={this.state.allUsers}
                                                placeholder="Busca y selecciona usuarios..."
                                                noOptionsMessage={() => "No se encontraron usuarios"}
                                                isClearable={true}
                                                closeMenuOnSelect={false}
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <button
                                                type="button"
                                                className="btn btn-success"
                                                onClick={this.handleAddUsers}
                                                disabled={this.state.addingUsers}
                                            >
                                                {this.state.addingUsers && (
                                                    <span className="spinner-border spinner-border-sm mr-1"></span>
                                                )}
                                                <i className="fa fa-plus mr-1"></i>
                                                Agregar
                                            </button>
                                        </div>
                                    </div>

                                    <hr />

                                    <h6>Usuarios en el Grupo ({this.state.clusterUsers.length})</h6>
                                    {this.state.clusterUsers.length === 0 ? (
                                        <div className="alert alert-info">
                                            No hay usuarios asignados a este grupo.
                                        </div>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Nombre</th>
                                                        <th>Celular</th>
                                                        <th>Rol</th>
                                                        <th className="text-center">Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.clusterUsers.map((user, index) => (
                                                        <tr key={user.id}>
                                                            <td>{index + 1}</td>
                                                            <td>{user.name} {user.last_name}</td>
                                                            <td>{user.Profile && user.Profile.cell_phonenumber ? user.Profile.cell_phonenumber : '-'}</td>
                                                            <td>{user.role}</td>
                                                            <td className="text-center">
                                                                <button
                                                                    className="btn btn-sm btn-danger"
                                                                    onClick={() => this.removeUserFromCluster(user.id, `${user.name} ${user.last_name}`)}
                                                                    title="Eliminar del grupo"
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </Fragment>
        )
    }
}

export default Ver_edit_customer_cluster
